import { newPasswordValidationType } from 'utils/types';
const passwordValidate = (
  value: string,
  onSubmit: boolean,
  passwordValidations: newPasswordValidationType,
): newPasswordValidationType => {
  const errorState = onSubmit ? 'fail' : 'unknown';
  const validatonState = { ...passwordValidations };
  validatonState['length'] = /^.{8,}$/.test(value) ? 'pass' : errorState;
  validatonState['lowerCase'] = /^(?=.*[a-z]).+$/.test(value)
    ? 'pass'
    : errorState;
  validatonState['upperCase'] = /^(?=.*[A-Z]).+$/.test(value)
    ? 'pass'
    : errorState;
  validatonState['number'] = /^(?=.*\d).+$/.test(value) ? 'pass' : errorState;
  return validatonState;
};

export default passwordValidate;
